import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbDrawer as ClbDrawer_ } from '@celebration/design-system/dist/lib/drawer';
const events = {
    onClbClose: ClbDrawer_.events.onClbClose,
    onClbHaveOpened: ClbDrawer_.events
        .onClbHaveOpened,
    onClbHaveClosed: ClbDrawer_.events
        .onClbHaveClosed,
};
export const ClbDrawer = createComponent({
    tagName: ClbDrawer_.tagName,
    elementClass: ClbDrawer_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map